import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Star, Zap } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#0A1628] pt-12 pb-20 px-4 overflow-hidden" data-id="element-120">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-121">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#1E3A5F] blur-3xl" data-id="element-122"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#D4AF37] blur-3xl" data-id="element-123"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-124">
        {/* Pre-headline */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black text-white text-sm font-bold uppercase tracking-wider mb-8" data-id="element-125">
          <Zap className="w-4 h-4 text-[#D4AF37]" data-id="element-126" />
          <span data-id="element-127">Atención Argentina: Nueva Oportunidad</span>
        </div>

        {/* Headline */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-8 text-balance uppercase" data-id="element-128">
          Aprendé{' '}
          <span className="text-[#D4AF37]" data-id="element-129">
            Detailing Automotriz Profesional
          </span>{' '}
          y Cobrá tus primeros trabajos en{' '}
          <span className="text-[#D4AF37]" data-id="element-130">15 días</span>
        </h1>

        {/* Product Mockup */}
        <a href="#comprar" onClick={scrollToPricing} className="block max-w-4xl mx-auto mb-8 transform transition-transform hover:scale-[1.02] cursor-pointer group" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/jE6GniNezxYjS8JwYVLZwK/Diseno_sin_titulo_(3).png" alt="Mega Pack Detailing Pro - 5 Tomos + 3 Bonos Profesionales" className="w-full h-auto rounded-2xl shadow-2xl shadow-[#D4AF37]/20 group-hover:shadow-[#D4AF37]/40 transition-shadow duration-500" data-id="element-132" />
        </a>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-4xl mx-auto mb-12 leading-relaxed text-balance" data-id="element-133">
          El sistema paso a paso para aprender detailing desde cero, evitar
          errores costosos y empezar a generar ingresos trabajando con autos.
        </p>

        {/* CTA */}
        <div className="flex flex-col items-center" data-id="element-134">
          <CTAButton text="QUIERO EMPEZAR AHORA" className="w-full md:w-auto md:min-w-[400px] text-xl py-6" data-id="element-135" />
          <p className="mt-4 text-sm text-gray-400 font-medium flex items-center gap-2" data-id="element-136">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-137" />
            Pago 100% Seguro y Acceso Inmediato
          </p>
        </div>
      </div>
    </section>;
}